<div class="image-container"
     [ngStyle]="{
           'background-image': 'url(' + image + ')',
           'height': height && height > 0 ? height + 'px' : '100%',
           'width': width && width > 0 ? width + 'px' : '100%'
           }">
  <div class="ff-blurry-backdrop" [ngClass]="{'error-image': hasError}">
    <img src="{{image}}" (load)="afterLoadingImage()" (error)="loadImageError()" onerror="this.onerror=null;this.src='assets/images/No_Image.png';">
  </div>

  <div class="blurry-backdrop" [ngClass]="{'error-image': hasError}">
    <img src="{{image}}" (load)="afterLoadingImage()" (error)="loadImageError()" onerror="this.onerror=null;this.src='assets/images/No_Image.png';">
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/core/blurry-backdrop-image/blurry-backdrop-image.component.html